export default {
  UNDEFINED: 0,
  EMAIL: 1,
  SMS: 2
};